import * as z from 'zod';

import { BorrowerId, DisbursementId, EscrowDueId, LoanId, PayeeId, PropertyId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { PayeePaymentMethod } from '../payee/Payee';

export const DisbursementPayeeType = z.enum([
  'taxEscrowSetting',
  'insuranceEscrowSetting',
  'mortgageInsuranceEscrowSetting',
  'borrower',
  'serviceProvider',
]);
export type DisbursementPayeeType = z.infer<typeof DisbursementPayeeType>;

export const DisbursementType = z.enum([
  'servicingTransfer',
  'escrow',
  'payoff',
  'forwardPayment',
  'paymentAfterPayoff',
]);

export const Disbursement = z.object({
  id: DisbursementId,
  loanId: LoanId,
  total: z.number(),
  type: DisbursementType,
  isReversal: z.boolean(),
  amounts: z.object({
    escrow: z.number(),
    suspense: z.number(), // statement suspense
    futureStatementSuspense: z.number().default(0),
    unappliedSuspense: z.number().default(0),
    principalPrepayment: z.number(),
    principal: z.number().optional().default(0),
    interest: z.number().optional().default(0),
    fee: z.number().optional().default(0),
    reserve: z.number().optional().default(0),
    holdback: z.number().optional().default(0),
    lossDraft: z.number().optional().default(0),
  }),
  date: zodJSPlainDate,
  recipient: z.string(),
  payeeId: PayeeId.optional(),
  borrowerId: BorrowerId.optional(),
  transactionId: z.string().optional(),
  status: z.literal('PROCESSED'),
  paymentMethod: PayeePaymentMethod.optional(),
  comment: z.string().optional(),
  escrowDueId: EscrowDueId.optional(),
  propertyId: PropertyId.optional(), // For disbursement instances where we lack an escrowId to tie into a property
  createdDate: zodJSInstantDate.optional(),
});
export type Disbursement = z.infer<typeof Disbursement>;
